import styled from 'styled-components'

export const Text = styled.span`
  padding-left: 2rem;
`

export const Trigger = styled.div`
  display: flex;
`

export const MenuItems = styled.div`
  ${({ theme: { colors } }) => `
    position: absolute;
    background: ${colors('background')};
    z-index: 999;
    min-width: 10rem;
    min-height: 10rem;
  `}
`

export const MenuItem = styled.div`
  ${({ $display }) => `
    display: ${$display ? 'visible' : 'none'};
`}
`

export const Container = styled.div`
  ${({ height, open, theme: { colors } }) => `
    position: relative;
    border: 1px solid ${colors('chrome')};
    overflow: ${open ? 'visible' : 'hidden'};
    height: ${height}px;
    z-index: 999;
  `}
}
`
